import { createMuiTheme } from '@material-ui/core';

const theme = createMuiTheme({
    appDrawer: {
        backgroundColor: '#2C3039',
        width: 260,
        collapsedWidth: 80,
        textColor: '#96989C',
    },
    toolbar: {
        desktopHeight: 64,
        mobileHeight: 48,
    },
    palette: {
        primary: {
            main: '#554DF0',
        },
        background: {
            default: '#F2F6FF',
        },
        success: {
            main: '#39CB85',
            light: '#D2F7EC',
        },
        error: {
            main: '#F74C62',
            light: '#FEE9EC',
        },
        text: {
            primary: '#2C3039',
        },
        additional: {
            blue: '#19AEFF',
            purple: '#DC6FEE',
            orange: '#FF9340',
            green: '#39CB85',
            border: '#DDE5F9',
        },
    },
    zIndex: {
        appBar: 1300,
        drawer: 1100,
        modal: 1400,
    },
    typography: {
        fontFamily: 'Poppins, Arial',
        fontWeightSemiBold: 600,
        h4: {
            fontWeight: 600,
            fontSize: '2.25rem',
            lineHeight: '3.375rem',
            letterSpacing: '0.00125rem',
        },
        h5: {
            fontWeight: 700,
            fontSize: '1.5rem',
            lineHeight: '2.25rem',
            letterSpacing: '0.00125rem',
        },
        h6: {
            fontWeight: 600,
        },
        subtitle1: {
            fontWeight: 600,
            fontSize: '1rem',
            lineHeight: '1.5rem',
            letterSpacing: '0.00125rem',
        },
        subtitle2: {
            fontWeight: 600,
        },
        body1: {
            fontWeight: 400,
            fontSize: '1rem',
            lineHeight: 1.5,
            letterSpacing: '0.00125rem',
        },
        body2: {
            fontWeight: 400,
            fontSize: '0.875rem',
            lineHeight: 1.3125,
            letterSpacing: '0.0025rem',
        },
        button: {
            fontWeight: 500,
            fontSize: '1rem',
            lineHeight: 1.5,
            letterSpacing: '0.0025rem',
        },
        caption: {
            fontWeight: 400,
            fontSize: '0.75rem',
            lineHeight: 1.5,
            letterSpacing: '0.00375rem',
        },
        overline: {
            fontWeight: 500,
            fontSize: '0.75rem',
            lineHeight: 1.125,
            letterSpacing: '0.00375rem',
            color: '#AEBBCB',
        }
    },
    shape: {
        borderRadius: 10,
    },
    shadows: [
        'none',
        '2px 16px 36px -12px rgba(85, 77, 240, 0.16);',
        '0px 3px 1px -2px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 0px rgba(0,0,0,0.12)',
        '0px 3px 3px -2px rgba(0,0,0,0.2),0px 3px 4px 0px rgba(0,0,0,0.14),0px 1px 8px 0px rgba(0,0,0,0.12)',
        '0px 2px 4px -1px rgba(0,0,0,0.2),0px 4px 5px 0px rgba(0,0,0,0.14),0px 1px 10px 0px rgba(0,0,0,0.12)',
        '0px 3px 5px -1px rgba(0,0,0,0.2),0px 5px 8px 0px rgba(0,0,0,0.14),0px 1px 14px 0px rgba(0,0,0,0.12)',
        '0px 3px 5px -1px rgba(0,0,0,0.2),0px 6px 10px 0px rgba(0,0,0,0.14),0px 1px 18px 0px rgba(0,0,0,0.12)',
        '0px 4px 5px -2px rgba(0,0,0,0.2),0px 7px 10px 1px rgba(0,0,0,0.14),0px 2px 16px 1px rgba(0,0,0,0.12)',
        '0px 5px 5px -3px rgba(0,0,0,0.2),0px 8px 10px 1px rgba(0,0,0,0.14),0px 3px 14px 2px rgba(0,0,0,0.12)',
        '0px 5px 6px -3px rgba(0,0,0,0.2),0px 9px 12px 1px rgba(0,0,0,0.14),0px 3px 16px 2px rgba(0,0,0,0.12)',
        '0px 6px 6px -3px rgba(0,0,0,0.2),0px 10px 14px 1px rgba(0,0,0,0.14),0px 4px 18px 3px rgba(0,0,0,0.12)',
        '0px 6px 7px -4px rgba(0,0,0,0.2),0px 11px 15px 1px rgba(0,0,0,0.14),0px 4px 20px 3px rgba(0,0,0,0.12)',
        '0px 7px 8px -4px rgba(0,0,0,0.2),0px 12px 17px 2px rgba(0,0,0,0.14),0px 5px 22px 4px rgba(0,0,0,0.12)',
        '0px 7px 8px -4px rgba(0,0,0,0.2),0px 13px 19px 2px rgba(0,0,0,0.14),0px 5px 24px 4px rgba(0,0,0,0.12)',
        '0px 7px 9px -4px rgba(0,0,0,0.2),0px 14px 21px 2px rgba(0,0,0,0.14),0px 5px 26px 4px rgba(0,0,0,0.12)',
        '0px 8px 9px -5px rgba(0,0,0,0.2),0px 15px 22px 2px rgba(0,0,0,0.14),0px 6px 28px 5px rgba(0,0,0,0.12)',
        '0px 8px 10px -5px rgba(0,0,0,0.2),0px 16px 24px 2px rgba(0,0,0,0.14),0px 6px 30px 5px rgba(0,0,0,0.12)',
        '0px 8px 11px -5px rgba(0,0,0,0.2),0px 17px 26px 2px rgba(0,0,0,0.14),0px 6px 32px 5px rgba(0,0,0,0.12)',
        '0px 9px 11px -5px rgba(0,0,0,0.2),0px 18px 28px 2px rgba(0,0,0,0.14),0px 7px 34px 6px rgba(0,0,0,0.12)',
        '0px 9px 12px -6px rgba(0,0,0,0.2),0px 19px 29px 2px rgba(0,0,0,0.14),0px 7px 36px 6px rgba(0,0,0,0.12)',
        '0px 10px 13px -6px rgba(0,0,0,0.2),0px 20px 31px 3px rgba(0,0,0,0.14),0px 8px 38px 7px rgba(0,0,0,0.12)',
        '0px 10px 13px -6px rgba(0,0,0,0.2),0px 21px 33px 3px rgba(0,0,0,0.14),0px 8px 40px 7px rgba(0,0,0,0.12)',
        '0px 10px 14px -6px rgba(0,0,0,0.2),0px 22px 35px 3px rgba(0,0,0,0.14),0px 8px 42px 7px rgba(0,0,0,0.12)',
        '0px 11px 14px -7px rgba(0,0,0,0.2),0px 23px 36px 3px rgba(0,0,0,0.14),0px 9px 44px 8px rgba(0,0,0,0.12)',
        '0px 11px 15px -7px rgba(0,0,0,0.2),0px 24px 38px 3px rgba(0,0,0,0.14),0px 9px 46px 8px rgba(0,0,0,0.12)',
    ],
    overrides: {
        MuiMenu: {
            paper: {
                maxHeight: '300px',
            },
        },
        MuiTable: {
            root: {
                borderCollapse: 'separate',
            },
        },
        MuiTableCell: {
            root: {
                borderBottom: 'none',
            }
        }
    }
});

export default theme;
